import React, { useState, useEffect } from 'react';
import { LogD } from '../../../function/LogLapper';
import { RealTimeTrendSettingModel } from './RealTimeTrendGraph';
import { GetUnitWithClc } from '../GroupSettings/TrendSetting/TrendSetting';
import { GetMeasureClcName, GetVibrationSpecialStringByKindNo } from '../../../Constant';
import { useTranslation } from 'react-i18next';

type Props = {
  setData: RealTimeTrendSettingModel;
  isShowOnChange: (event: React.ChangeEvent<HTMLInputElement>, index: number) => void;
  isRowSelectClick: (index: number) => void;
  isRowSelectDoubleClick: () => void;
};

const RealTimeTrendGraphItemInfo: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const isDispLog: boolean = false;
  console.debug(['==RealTimeTrendGraphItemInfo== ', props.setData]);

  const tableStyle: React.CSSProperties = {
    borderWidth: '1px',
    borderColor: '#aaaaaa',
    borderStyle: 'solid',
    backgroundColor: `${props.setData.LineColor}`,
    borderCollapse: `collapse`,
    marginLeft: '3px',
    width: '12%',
  };

  const tdStyle = {
    borderWidth: '1px',
    borderColor: '#aaaaaa',
    borderStyle: 'solid',
    background: props.setData.IsRowSelect ? '#ffff00' : '#ffffff',
    padding: '0px',
  };

  const tdStyleColor = {
    borderWidth: '1px',
    borderColor: '#aaaaaa',
    borderStyle: 'solid',
    background: `${props.setData.LineColor}`,
    padding: '0px',
  };

  //console.debug(['- 画面描画開始 -', props.setData]);
  return (
    <table style={tableStyle}>
      <tbody
        onDoubleClick={() => {
          props.isRowSelectDoubleClick();
        }}
      >
        <tr>
          <td style={tdStyleColor} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            <input
              type="checkbox"
              checked={props.setData.IsShow}
              onChange={(e) => props.isShowOnChange(e, props.setData.IndexNo)}
            />
          </td>
        </tr>
        <tr>
          <td style={tdStyle} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {GetVibrationSpecialStringByKindNo(props.setData.Kind, t) === ''
              ? props.setData.MeasureKindName
              : GetVibrationSpecialStringByKindNo(props.setData.Kind, t)}{' '}
            &nbsp;
          </td>
        </tr>
        <tr>
          <td style={tdStyle} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {props.setData.MachineIndex != '0' && props.setData.MachineIndex + props.setData.MachineName}&nbsp;
          </td>
        </tr>
        <tr>
          <td style={tdStyle} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {props.setData.ItemName}&nbsp;
          </td>
        </tr>
        <tr>
          {/* データ種別 */}
          <td style={tdStyle} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {GetMeasureClcName(props.setData.Clc, props.setData.OperationProcess, t)}&nbsp;
          </td>
          <td style={tdStyle} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {GetUnitWithClc(
              Number(props.setData.PLCNo),
              props.setData.UnitSymbol,
              props.setData.Clc,
              Number(props.setData.MeasureKindNo),
              props.setData.Kind
            )}
            &nbsp;
          </td>
        </tr>
        <tr>
          <td style={tdStyle} colSpan={2} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {props.setData.TypeName}&nbsp;
          </td>
        </tr>
        <tr>
          <td style={tdStyle} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {props.setData.PLCNo !== '' ? Number(props.setData.RealTimeTrendValueUpper).toFixed(4) : ' '}&nbsp;
          </td>
          <td style={tdStyle} onClick={() => props.isRowSelectClick(props.setData.IndexNo)}>
            {props.setData.PLCNo !== '' ? Number(props.setData.RealTimeTrendValueUpperLimit).toFixed(4) : ' '}&nbsp;
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default RealTimeTrendGraphItemInfo;
